import createIcon from '@/lib/create-icon'
import React from 'react'

export const CopySVGIcon = createIcon(
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_532_4063)">
      <path
        d="M2.5 8H2C1.73478 8 1.48043 7.89464 1.29289 7.70711C1.10536 7.51957 1 7.26522 1 7V2.5C1 2.23478 1.10536 1.98043 1.29289 1.79289C1.48043 1.60536 1.73478 1.5 2 1.5H6.5C6.76522 1.5 7.01957 1.60536 7.20711 1.79289C7.39464 1.98043 7.5 2.23478 7.5 2.5V3M5.5 5H10C10.5523 5 11 5.44772 11 6V10.5C11 11.0523 10.5523 11.5 10 11.5H5.5C4.94772 11.5 4.5 11.0523 4.5 10.5V6C4.5 5.44772 4.94772 5 5.5 5Z"
        stroke="currentColor"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_532_4063">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>,
)
